<script lang="ts" setup>
  import { mdAndUp } from '@/composables/breakpoints'

  defineProps<{
    isSignedIn: boolean
  }>()

  defineEmits<{
    (event: 'account'): void
    (event: 'close'): void
  }>()
</script>

<template>
  <div class="c-nav-panel">
    <icon-grilld-logo-text-red aria-label="Grill'd logo" class="logo-grilld" height="44" width="62" />

    <template v-if="mdAndUp">
      <icon-ionic-close aria-label="close" class="icon-close" height="24" width="24" @click="$emit('close')" />
    </template>

    <template v-else>
      <div class="nav-end-container">
        <icon-ionic-person
          v-if="!isSignedIn"
          aria-label="account"
          class="icon-account"
          height="24"
          width="24"
          @click="$emit('account')"
        />
        <icon-ionic-close aria-label="close" class="icon-close" height="24" width="24" @click="$emit('close')" />
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .c-nav-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-height: var(--navbar-height);
    padding: 14px 16px;
    color: var(--color-base-black);

    background-color: var(--color-base-paper);

    .nav-end-container {
      display: flex;
      align-items: center;
      column-gap: 12px;
    }

    .icon-account {
      cursor: pointer;
    }

    .icon-close {
      cursor: pointer;
    }
  }
</style>
